import { render, staticRenderFns } from "./SupplierHeader.vue?vue&type=template&id=4d4f8956&scoped=true"
import script from "./SupplierHeader.vue?vue&type=script&lang=js"
export * from "./SupplierHeader.vue?vue&type=script&lang=js"
import style0 from "./SupplierHeader.vue?vue&type=style&index=0&id=4d4f8956&prod&lang=css"
import style1 from "./SupplierHeader.vue?vue&type=style&index=1&id=4d4f8956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f8956",
  null
  
)

export default component.exports